import {PromotionType} from "../../../promotion/helpers/PromotionType";
import {IPromotionBooster} from "../../types/booster_generic/IPromotionBooster";
import {IBoosterCategory} from "../../types/IBoosterCategory";
import {IBoosterTextSegmentType} from "../../types/IBoosterTextSegmentType";
import {isPromotionAvailable} from "../../utils/promotions/is_promotion_available";
import {showMoreInfoTextSegmentConfig} from "../common/common_booster_text_segments";

export const promotionPromotionBooster: IPromotionBooster = {
    category: IBoosterCategory.Promotion,
    type: PromotionType.PROMOTION,

    isValid(params) {
        return isPromotionAvailable(params.promotions, PromotionType.PROMOTION);
    },

    getSegments() {
        return [
            "Aktualnie obowiązuje",
            {
                type: IBoosterTextSegmentType.HIGHLIGHTED,
                text: "oferta promocyjna"
            },
            showMoreInfoTextSegmentConfig
        ];
    }
};
import {PromotionType} from "../../../promotion/helpers/PromotionType";
import {IPromotionBooster} from "../../types/booster_generic/IPromotionBooster";
import {IBoosterCategory} from "../../types/IBoosterCategory";
import {IBoosterTextSegmentType} from "../../types/IBoosterTextSegmentType";
import {isPromotionAvailable} from "../../utils/promotions/is_promotion_available";
import {showMoreInfoTextSegmentConfig} from "../common/common_booster_text_segments";

export const promotionPromotionBooster: IPromotionBooster = {
    category: IBoosterCategory.Promotion,
    type: PromotionType.PROMOTION,

    isValid(params) {
        return isPromotionAvailable(params.promotions, PromotionType.PROMOTION);
    },

    getSegments() {
        return [
            "Aktualnie obowiązuje",
            {
                type: IBoosterTextSegmentType.HIGHLIGHTED,
                text: "oferta promocyjna"
            },
            showMoreInfoTextSegmentConfig
        ];
    }
};
